module.exports = __webpack_public_path__ + "media/assets/faria_products/Integrations-f2816bad68bf8a868f9d059ff26e95eac1132946ee3be54f9d2ba5ea2bb4718f.png";